import { createContext, memo } from 'react';

export const SearchContext = createContext<string>('search');

const SearchContextProvider = SearchContext.Provider;

export default memo(SearchContextProvider);
